import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useLogout() {
	const client = useQueryClient();
	return useMutation({
		mutationKey: ["auth"],
		mutationFn: async () => {
			await fetch(`${SERVICE_API}/api/auth/logout`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify({}),
				headers: {
					"Content-Type": "application/json",
				},
			});
			client.setQueryData(["auth"], {
				authenticated: false,
				user: undefined,
			});
		},
	});
}
